module.exports = __webpack_public_path__ + "img/brush-fill.e00aa840.svg";